import { render, staticRenderFns } from "./ApplianceType.vue?vue&type=template&id=50cf0f56"
import script from "./ApplianceType.vue?vue&type=script&lang=js"
export * from "./ApplianceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports